import Clear from '@material-ui/icons/Clear';
import classnames from 'classnames';
import Drawer from 'material-ui/Drawer';
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import Loading from 'swag-client-common/components/info/loading';
import { hideIntercom } from '../../../../../scripts/customer/utils/ui.utils';
import { is1024andSmaller } from '../../../utils/ui.utils';
import MobileHeader from '../mobile-header';
import NoResultsMessage from './components/no-results-message';
import { SearchResults } from './components/search-results';
import classes from './search-products.scss';
import SearchIcon from './components/search-icon';
const containerStyle = {
  overflow: 'visible'
};
export const SearchProductsComponent = ({
  onPageScrollBlock,
  onFocus,
  onLinkClick,
  onClear,
  onDeactivate,
  isActive,
  isSearchResultsShown,
  isLoading,
  searchResults,
  onSearch,
  query,
  total,
  noResults,
  isMobileIconShown,
  onGoToSearchResultsPage,
  searchSuggestions,
  ignoreMobileChanges = false
}) => {
  const isMobileView = is1024andSmaller() && !ignoreMobileChanges;
  const activeInputClass = classes.isActive;
  const isRenderDrawer = isActive && isSearchResultsShown;
  const searchInputRef = useRef(null);
  const searchResultsContainerRef = useRef(null);
  const focusSearch = () => {
    var _searchInputRef$curre, _searchInputRef$curre2;
    searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : (_searchInputRef$curre2 = _searchInputRef$curre.focus) === null || _searchInputRef$curre2 === void 0 ? void 0 : _searchInputRef$curre2.call(_searchInputRef$curre);
  };
  const onSearchFocus = () => {
    if (is1024andSmaller() && !ignoreMobileChanges) {
      hideIntercom(true);
    }
    if (onFocus) {
      onFocus(is1024andSmaller() && !ignoreMobileChanges);
    }
    if (onPageScrollBlock) {
      onPageScrollBlock(is1024andSmaller() && !ignoreMobileChanges);
    }
    document.addEventListener('click', deactivate);
    localStorage.removeItem('productId');
  };
  const onRootClick = e => {
    e.nativeEvent.stopImmediatePropagation();
  };
  const onPressEnter = e => {
    if (e.charCode === 13 && query) {
      onGoToSearchResultsPage(query);
    }
  };
  const handleLinkClick = () => {
    onLinkClick();
    deactivate();
  };
  const clear = () => {
    onClear();
    if (onFocus) {
      onFocus(false);
    }
    onSearch('');
  };
  const handleSearch = event => {
    var _event$target;
    onSearch((event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) || '');
  };
  const deactivate = () => {
    if (is1024andSmaller() && !ignoreMobileChanges) {
      hideIntercom();
    }
    onDeactivate(query);
    onPageScrollBlock(false);
    document.removeEventListener('click', deactivate);
  };
  useEffect(() => {
    return () => {
      onPageScrollBlock(false);
    };
  }, []);
  useLayoutEffect(() => {
    var _searchResultsContain;
    if (!((_searchResultsContain = searchResultsContainerRef.current) !== null && _searchResultsContain !== void 0 && _searchResultsContain.clientHeight) || is1024andSmaller()) {
      return;
    }
    const searchHeight = searchResultsContainerRef.current.clientHeight;
    const viewportHeight = window.innerHeight;
    const availableHeight = viewportHeight - searchResultsContainerRef.current.getBoundingClientRect().top;
    if (searchHeight > availableHeight) {
      const transformRatio = ((availableHeight - 10) / searchHeight).toFixed(2);
      searchResultsContainerRef.current.style.transform = `scale(${transformRatio})`;
    } else {
      searchResultsContainerRef.current.style.transform = '';
    }
  });
  const renderContent = () => /*#__PURE__*/React.createElement("div", {
    onClick: onRootClick,
    className: classnames(classes.container, {
      [activeInputClass]: isActive,
      [classes.bringForward]: isActive
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.innerContainer)
  }, isActive && /*#__PURE__*/React.createElement(MobileHeader, {
    onClose: deactivate,
    headerText: "search"
  }), /*#__PURE__*/React.createElement("label", {
    className: classes.searchLabel,
    htmlFor: "searchField"
  }, "Search:"), /*#__PURE__*/React.createElement("input", {
    id: "searchField",
    "data-element": "search",
    placeholder: isMobileView ? 'Search by product' : 'Search by product name or type',
    value: query,
    className: classes.input,
    onChange: handleSearch,
    onKeyPress: onPressEnter,
    onFocus: onSearchFocus,
    ref: searchInputRef,
    tabIndex: 0
  }), !isActive && /*#__PURE__*/React.createElement("span", {
    className: classes.mobileSearchIconContainer,
    onClick: focusSearch
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: classnames(classes.mobileSearchIcon, classes.icon, {
      [classes.showIcon]: isMobileIconShown
    })
  })), isActive && isSearchResultsShown && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.resultBox, {
      [classes.noResults]: isLoading || noResults,
      [classes.noPadding]: !(searchResults !== null && searchResults !== void 0 && searchResults.length)
    }),
    ref: searchResultsContainerRef
  }, isLoading && /*#__PURE__*/React.createElement(Loading, null), noResults && /*#__PURE__*/React.createElement(NoResultsMessage, null), searchResults && !isLoading && !noResults && /*#__PURE__*/React.createElement(SearchResults, {
    onLinkClick: handleLinkClick,
    onButtonClick: () => onGoToSearchResultsPage(query),
    searchResults: searchResults,
    total: total,
    searchSuggestions: searchSuggestions,
    onSuggestionClick: handleSearch
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.desktopClearIconContainer
  }, !!query.length && /*#__PURE__*/React.createElement(Clear, {
    className: classes.desktopClearIcon,
    onClick: clear
  })));
  return isRenderDrawer && isMobileView ? /*#__PURE__*/React.createElement(Drawer, {
    docked: false,
    openSecondary: true,
    width: "100%",
    open: isRenderDrawer,
    containerStyle: containerStyle
  }, renderContent()) : renderContent();
};